import React from "react";
import "./GetStarted.css";
const GetStarted = () => {
  return (
    <>
      <div className="get-started-section">
      <div className="container py-5">
        <h4 className="text-center fw-bold mb-4">It’s easy to get started</h4>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="get-started-wrapper">
              <div className="get-started-border"></div>
              <div className="get-started-box">
                <h6>Sign up</h6>
                <p>Create an account for free using your email address.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="get-started-wrapper">
              <div className="get-started-border"></div>
              <div className="get-started-box">
                <h6>Explore the platform</h6>
                <p>
                  See what it’s like to invest without putting your money at
                  risk by practicing on a demo account.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="get-started-wrapper">
              <div className="get-started-border"></div>
              <div className="get-started-box">
                <h6>Invest &amp; earn profit</h6>
                <p>Select an asset and make your money work for you.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
   
    </>
  );
};

export default GetStarted;
